import config from "@/config";
import Axios from "@/utils/Axios";

export const promptExpand = async (prompt: string): Promise<IRes<{ text: string }>> => {
  return await Axios.post(
    "/chatgpt-creator/expand_text",
    {
      prompt,
    },
    {},
    config.adminUrl,
  );
};
